import request from 'sb-request'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { shippingForm } from 'pages/paymentNew/SubscribePrototypePage/util/forms'
import { object, constants } from 'common/helpers'
import { getFeatureToggle } from 'helpers'
import { getBillData as getSubscribePageBillData } from 'pages/paymentNew/SubscribePrototypePage/util/bill'


const getAddressFieldValues = () => {
  const fieldNames = [ 'street', 'zipCode', 'state', 'city' ]
  const result = {}

  fieldNames.forEach((fieldName) => {
    result[fieldName] = shippingForm.fields[fieldName].value
  })

  return result
}

const setBillItems = () => {
  const {
    models: { me: { gender } },
    view: { paymentPage: { selectedPlan } },
  } = getState()

  setInquireAndBillData({ gender, selectedPlan, inquireData: { coupon: {} } })
}

const inquireSubscription = (values) => {
  const { offer, coupon, subscriptionCase, couponCode, couponType = 'order', plan, isCouponFromUser = false } = values
  const { view: { pickPage: { selectedItems = [] } } } = getState()

  const isPremiumProductsForNotSubscribedEnabled = getFeatureToggle(constants.features.premiumProductsForNotSubscribed)

  const query = {
    ...getAddressFieldValues(),
    subscriptionCase,
    plan,
  }

  if (isPremiumProductsForNotSubscribedEnabled && selectedItems.length) {
    query.pickedProducts = selectedItems.map(({ id }) => id).join()
  }

  if (offer) {
    query.offer = offer
  }

  if (coupon && coupon.id) {
    query.coupon = coupon.id
  }

  if (couponCode) {
    query.couponCode = couponCode
    query.couponFromUser = isCouponFromUser
  }

  if (couponType) {
    query.couponType = couponType
  }

  return request.get('rest/subscription/inquire', {
    query,
    multiple: false,
    modifyResult: (response) => {
      const {
        subscription, cart, discount, tax, price, upchargePrice,
        coupon: couponCode, discountCode, offer, pickedProducts,
        subscriptionCasePrice, creditCardAuthorizationFee,
      } = response

      return {
        subscription: {
          ...object.removeKeys(subscription, [ 'tax' ]),
          price: subscription.price,
        },
        cart: cart || {},
        bill: {
          creditCardAuthorizationFee: creditCardAuthorizationFee || 0,
          price,
          upchargePrice,
          discount,
          offer,
          tax,
        },
        coupon: {
          isFetching: false,
          code: couponCode,
          errors: discountCode && discountCode.errors ? discountCode.errors : null,
          couponType: discountCode && discountCode.code ? discountCode.code.couponType : null,
          offerType: discountCode && discountCode.code ? discountCode.code.marketingCouponOfferType : null,
        },
        pickedProducts,
        subscriptionCasePrice,
      }
    },
  })
    .then(
      (data) => data,
      (error) => console.log(error)
    )
}

const setInquireFetchingStatus  = reducers.view.subscribePrototypePage.setInquireFetchingStatus
const setOutOfStockProducts     = reducers.view.subscribePrototypePage.setOutOfStockProducts
const setPaymentMethod          = reducers.view.subscribePrototypePage.setPaymentMethod

const setIsShippingValid        = (isValid) => {
  actions.misc.cookies.setItem(constants.cookieNames.isShippingFormValid, true)
  reducers.view.subscribePrototypePage.setIsShippingValid(isValid)
}

const setInquireAndBillData     = ({ gender, selectedPlan, inquireData }) => {
  const { view: { subscribePrototypePage: { paymentMethod } } } = getState()

  const bill = getSubscribePageBillData({ ...inquireData, gender, selectedPlan, paymentMethod })

  reducers.view.subscribePrototypePage.setInquireAndBillData({ bill, inquireData })
}


export default {
  inquireSubscription,
  setInquireAndBillData,
  setInquireFetchingStatus,
  setOutOfStockProducts,
  setIsShippingValid,
  setPaymentMethod,
  setBillItems,
}
